export enum MonekColour {
  Primary = 'primary',
  Warn = 'warn',
  Accent = 'accent',
}
